<template>
  <span>
    <slot :open="open">
      <a href="javascript:void(0)" @click="open">{{ linkText || "Default link text" }}</a>
    </slot>
  </span>
</template>

<script>
/**
 * Link for opening ModalWindow
 */
import CommonMixin from "@/components/DigitalEvent/mixins/CommonMixin";

export default {
  name: "ModalWindowLink",
  mixins: [CommonMixin],
  props: {
    modalWindowName: {
      type: String,
      default: "default"
    },
    linkText: {
      type: String,
      default: null
    },
    context: {
      type: Object,
      default: function() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  methods: {
    open(ctx) {
      this.$modal.show(this.modalWindowName, {
        name: this.modalWindowName,
        context: ctx && !ctx.target ? ctx : this.context,
        options: this.options
      });
    }
  },
  mounted() {
    let $vm = this;
    // workaround for cloned slides - listen for clicks
    const modalOpeners = document.getElementsByClassName("modal-opener");
    modalOpeners.forEach(el => {
      el.addEventListener("click", e => {
        // stop propagation across other elements of same class
        e.stopPropagation();
        e.stopImmediatePropagation();
        let link = e.currentTarget;
        let context = {
          title: link.dataset.title,
          url: link.dataset.url
        };
        $vm.open(context);
      });
    });
  }
};
</script>
